@if (initialized) {
  <div class="flex lg:align-items-start flex-column lg:flex-row p-4 border-round border-1"
  [ngClass]="isInsurableObjectsAvailable ?  'bg-blue-100 border-blue-300' : 'bg-yellow-100 border-yellow-300'">
    <div class="flex align-items-start">
      <i class=" text-blue-900 text-2xl mr-3"
      [ngClass]="isInsurableObjectsAvailable ? 'pi pi-eye' : 'pi pi-info-circle'"></i>
      <div class="mr-3 flex lg:align-items-start flex-column lg:flex-row">
        <p class="m-0 p-0 text-700 line-height-3">
          @if (isInsurableObjectsAvailable) {
            Wir überprüfen derzeit die Verträge, die du uns gemeldet hast.
          }
          @else if (!isInsurableObjectsAvailable) {
            Teile uns mit, welche weiteren Verträge von uns betreut werden sollen!
          }
        </p>
      </div>
    </div>
    <a pRipple class="flex align-items-center ml-auto no-underline text-900 font-medium mt-3 lg:mt-0 cursor-pointer"
       (click)="navigateToContacts()">
      <span>
         @if (isInsurableObjectsAvailable) {
           Klicke hier, um uns weitere Verträge mitzuteilen.
         }
         @else if (!isInsurableObjectsAvailable) {
           Weitere Verträge hochladen
         }
      </span>
      <i class="pi pi-arrow-right text-blue-900 ml-2"></i>
    </a>
  </div>



}
